<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>
        <component :is="$store.state.modal.type"/>
        <notifications group="info" />
        <router-view/>
    </div>
</template>

<script>
import Modals from './components/modals';
export default {
    name: 'app',
    components: {
        ...Modals
    },
    data() {
        return {};
    },
    methods: {
        fetchData() {
            setInterval(() => {
                if (this.$store.state.isInitiated) {
                    this.$store.dispatch('getDocumentCounts', this.year);
                    this.$store.dispatch('getGoalCounts', this.year);
                    this.$store.dispatch('getAuditCounts', this.year);
                }
            }, 60000);
        }
    },
    watch: {
        '$store.state.year': function() {
            this.$store.dispatch('getDocumentCounts', this.year);
            this.$store.dispatch('getGoalCounts', this.year);
            this.$store.dispatch('getAuditCounts', this.year);
        },
        '$store.state.locale': function() {
            this.$i18n.locale = this.$store.state.locale;
        }
    },
    created() {
        this.fetchData();
        this.$i18n.locale = this.$store.state.locale;
    }
};
</script>

<style lang="scss">
@font-face {
    font-family: 'din_alternatebold';
    src: url('./assets/fonts/din_alternate_bold-webfont.eot');
    src: url('./assets/fonts/din_alternate_bold-webfont.eot?#iefix') format('embedded-opentype'),
        url('./assets/fonts/din_alternate_bold-webfont.woff2') format('woff2'),
        url('./assets/fonts/din_alternate_bold-webfont.woff') format('woff'),
        url('./assets/fonts/din_alternate_bold-webfont.ttf') format('truetype'),
        url('./assets/fonts/din_alternate_bold-webfont.svg#din_alternatebold') format('svg');
    font-weight: normal;
    font-style: normal;
}
.is-invalid {
    input {
        border-color: #dc3545 !important;
    }
    textarea {
        border-color: #dc3545 !important;
    }
    .el-range-editor {
        border-color: #dc3545 !important;
    }
    border-color: #dc3545 !important;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

body {
    background-color: #eff3f6;
}

.gray-select {
    color: #fff !important;
    font-size: 0.9em !important;
    background-color: #868e96 !important;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#fff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") !important;
    height: 100% !important;
    margin-left: 10px !important;
    &:focus {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='black' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") !important;
    }
    option {
        font-weight: normal !important;
        display: block !important;
        white-space: pre !important;
        min-height: 1.2em !important;
        padding: 0 2px 1px !important;
        color: #495057 !important;
        background: #fff !important;
    }
}


.gray-input {
    font-size: 0.9em !important;
    color: #fff !important;
    &::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #fff !important;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #fff !important;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #fff !important;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #fff !important;
    }
    background-color: #868e96 !important;
    height: 100% !important;
    &:focus {
        background-color: #fff !important;
        color: #868e96 !important;
        &::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #868e96 !important;
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #868e96 !important;
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #868e96 !important;
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #868e96 !important;
        }
    }
}

.white-select {
    color: #000 !important;
    border: 1px solid #495057 !important;
    font-size: 0.9em !important;
    background-color: #fff !important;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='black' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") !important;
    height: 100% !important;
    margin-left: 10px !important;
    &:focus {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='black' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") !important;
    }
    option {
        font-weight: normal !important;
        display: block !important;
        white-space: pre !important;
        min-height: 1.2em !important;
        padding: 0 2px 1px !important;
        color: #495057 !important;
        background: #fff !important;
    }
}

.link-basic {
    color: #3355ff;
}
.link-basic:hover {
    cursor: pointer;
    text-decoration: underline;
}

.form-control-custom {
    height: 100% !important;
    font-size: 0.875rem !important;
}

.edit-column {
    position: absolute;
    right: 0;
    background-color: white;
    margin-right: 20px;
    -webkit-box-shadow: -1px 0 3px -1px #ccc;
    box-shadow: -1px 0 3px -1px #ccc;
    border-left: 1px solid #ccc;
}

.insert-row {
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

td {
    text-align: center;
}

.tableBodyCell {
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
        margin: auto;
    }
    div {
    }
}

.table-button-group {
    background-color: white;
    height: inherit;
    display: flex;
    justify-content: center;
    button {
        color: rgba(136, 136, 136, 0.53);
        background-color: white;
        border-color: white;
    }
}

.multiselect__tags {
    padding: 12px 30px 0 8px;
    background: #868e96 !important;
    border: none;
    input::placeholder {
        color: #fff !important;
    }
    .multiselect__single,
    .multiselect__input {
        font-size: 1em;
        color: #fff !important;
        background: #868e96 !important;
    }
}
.multiselect__option {
    span {
        font-size: 0.9em;
    }
}
.multiselect__select:before {
    border-color: white transparent transparent !important;
}

.multiselect--active {
    z-index: 3 !important;
}

.placeholder-color-white {
    input::placeholder {
        color: #fff;
    }
}

.modal{
    overflow: auto !important;
}
.el-transfer-panel {
    width: 40% !important;
}
.input-field-warning-message {
    color: red;
    font-weight: normal;
}
.wide-message-box {
    width: 60% !important;
}

.vue-notification {
    padding: 10px;
    margin: 60px 5px 5px;

    font-size: 12px;

    color: #ffffff;
    background: #44a4fc;
    border-left: 5px solid #187fe7;

    &.warn {
        background: #ffb648;
        border-left-color: #f48a06;
    }

    &.error {
        background: #e54d42;
        border-left-color: #b82e24;
    }

    &.success {
        background: #68cd86;
        border-left-color: #42a85f;
    }
}

.tab-deactive {
    .nav-link {
        background-color: #ddd;
    }
}
.scroll-content {
    height: calc(100vh - 250px) !important;
    overflow-y: auto;
    overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue